import CreateAndEditRoleForm from "../../../components/views/user-roles/roles-form";

function CreateAndEditRolePage() {
  return <CreateAndEditRoleForm />;
}
export default CreateAndEditRolePage;
